import { useContext } from 'react'
import { useParams } from 'react-router'

import { NewsContext } from '../../News/News'
import { MDBContainer, MDBIcon, MDBRow } from 'mdb-react-ui-kit'

export const NewsDetail = () => {

    const newsList = useContext(NewsContext)

    const { id } = useParams()

    const news_ = newsList?.newsList
    
    if(news_ === undefined) return null

    const news = news_[Number(id)]

    const img = news?.img

    const heading = news?.heading

    const date = news?.date

    const body = news?.body

    const links = news?.links

    return (
        <>
            <MDBContainer className={'border border-0 border-danger pt-5 bg-light'}>
                <MDBContainer className={'border border-0 border-danger py-3'}>
                    <img src={img} className={"border border-0 border-danger  img-fluid rounded mb-5"} alt="Wild Landscape" />

                    <MDBRow className={'border border-0 border-warning h1 mb-2'}>
                        {heading}
                    </MDBRow>

                    <MDBRow className={'border border-0 border-danger mb-4'}>
                        <small className='border border-0 border-success ms-0 ps-0 text-muted'>
                            <MDBIcon far icon="calendar-alt" />{date}
                        </small>
                    </MDBRow>

                    <MDBRow className={'border border-0 border-danger'}>
                        {body?.map(
                            (val, index) => (
                                <p key={index} className={'border border-0 border-danger fw-light'}>{val}</p>
                            )
                        )}
                    </MDBRow>
                    <MDBRow className={'border border-0 border-danger'}>
                        {links?.map(
                            (val, index) => (
                                <p key={index} className={'border border-0 border-danger fw-light'}>
                                    <a href={val}>{val}</a>
                                </p>
                            )
                        )}
                    </MDBRow>
                </MDBContainer>
            </MDBContainer>
        </>
    )
}